module.exports = __webpack_public_path__ + "img/hest14.229ee8ce.jpg";